import styled from 'styled-components';

export const PasswordGuidelinesWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top:.5rem;
        padding-bottom:2rem;
    `
);

export const PasswordGuideLinesText = styled.p(
    props => `
        font-size:1.4rem;
        color: $000;
    `
);

export const ButtonTermsWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        margin-top:3rem;
    `
);

export const TermsTextWrap = styled.div(
    props => `
        display: flex;
    `
);

export const TermsText = styled.p(
    props => `
        font-size: 1.4rem;
        color: #000;
    `
);

export const EyeWrapper = styled.div(
    props => `
      position: absolute;
      height: 42px;
      right: 0;
      top: 0;
      display: flex;
      aling-items: center;
      justidy-content: center;
      border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
    `
);

export const StrongFailInfo = styled.div(
    props =>`
      position: absolute;
      height: 42px;
      border-right: 4px solid ${props.theme.colors.red.base};
      right: 0;
      top: 0;
      display: flex;
      aling-items: center;
      justidy-content: center;
      border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
    `
);

export const WeakText = styled.p(
    props =>`
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.red.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        display: flex;
        padding-top: ${props.theme.spacing.large.l13};
        padding-right: ${props.theme.spacing.large.l45};
    `
);

export const StrongPassInfo = styled.div(
    props => `
      position: absolute;
      height: 42px;
      border-right: 4px solid ${props.theme.colors.green.dark};
      right: 0;
      top: 0;
      display: flex;
      aling-items: center;
      justidy-content: center;
      border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
    `
);

export const StongText = styled.p(
    props =>`
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.green.dark};
        font-weight: ${props.theme.font.fontWeight.bold};
        display: flex;
        padding-top: ${props.theme.spacing.large.l13};
        padding-right: ${props.theme.spacing.large.l45};
    `
);

export const TickIconWrapper = styled.div(
    props => `
      width: 1.5rem;
      height: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${props.theme.colors.green.dark};
      border-radius: ${props.theme.misc.borderRadius.round};
      position: absolute;
      top: 4.1rem;
      right: 1rem;
      transform: translateY(-50%);
    `
);

export const TickErrorIconWrapper = styled.div(
    props => `
        width: 1.3rem;
        height: 1.3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props.theme.colors.red.base};
        border-radius: ${props.theme.misc.borderRadius.round};
        position: absolute;
        top: 2.1rem;
        right: 1rem;
        transform: translateY(-50%);
    `
);